import { Flex, HStack } from "@chakra-ui/react";
import type React from "react";

import { BannerAlert, Text } from "@equidefi/ui";
import { WorkflowContainer } from "../WorkflowContainer";

type WorkflowStepWrapperProps = {
  children?: React.ReactNode;
  button: React.ReactNode;
  poweredBy: React.ReactNode;
  hasAdditionalSigners?: boolean;
  onContinue?: () => void;
};

export const AgreementStepWrapper: React.FC<WorkflowStepWrapperProps> = ({
  children,
  button,
  poweredBy,
  hasAdditionalSigners = false,
}) => {
  return (
    <WorkflowContainer title="Subscription Agreement">
      <Text my="4">You must sign the subscription agreement to complete your investment.</Text>

      {hasAdditionalSigners && (
        <BannerAlert
          status="info"
          description="The additional signers you added will receive their invitation to sign after you have completed the signature process."
          mt="6"
        />
      )}

      {children}

      {button}

      <Flex align="center" direction="column" justify="center" my={6}>
        <Text mb={1} textStyle="context" textTransform="uppercase">
          Signature Process Powered By
        </Text>

        <HStack pointerEvents="none" opacity="0.6" gap={2}>
          {poweredBy}
        </HStack>
      </Flex>
    </WorkflowContainer>
  );
};
